<template>
  <div class="main-copy-tree">
		<b-table
			class="table"
			:items="sorce"
			:fields="['indicador']"
			select-mode="multi"
			responsive="sm"
			ref="table"
			sticky-header
			selectable
			small 
			@row-selected="onRowSelected">

		</b-table>

		<div class="space-select">
			<div v-if="selected.length > 0">
				<p class='mb-1'>{{ $t('indicadores-que-receberao-a-copia') }}</p>
				<div class="field-selected">
					<span class="lines-selected" v-for="(item, i) in selected" :key="i">
					{{item.indicador}} <strong class="btn-clear" :title="$t('remover-selecao')" @click="removeSelected(item)">x</strong>
					</span> 
				</div>
			</div>
		</div>

		<div class="groupBtn">
			<img
				src="@/assets/listaTecnica.png"
				style="margin-left: 30px"
				:title="$t('copiar')"
				:alt="$t('copiar')"
				@click="copy"
			/>
			<img
				src="@/assets/sair.png"
				style="margin-left: 30px"
				:title="$t('sair')"
				:alt="$t('sair')"
				@click="$bvModal.hide('CopyTreeToIndicator')"
			/>
		</div>
  </div>
</template>

<script>


	export default {
		name:"CopyTreeToIndicator",
		props: ["indicators"],

		data() {
				return {
					selected: [],
					selectedBkp: [],
					filter: "",
					sorce: this.indicators,
				}
		},

		watch: {
			filter(value){
				if(value)
					this.sorce = this.indicators.filter(i => i.indicador.toLocaleLowerCase().includes(value.toLocaleLowerCase()))
				else
					this.sorce = this.indicators;

				this.$refs.table.refresh()

				this.selected.forEach(item => {
					let index =  this.sorce.indexOf(item);
					console.log('index :>> ', index);
					if(index != -1){
						this.$refs.table.selectRow(index)

					}
				})
			}
		},

		methods: {

			onRowSelected(items) {
				this.selected = items
			},

			removeSelected(item){
        if(this.selected.length > 1){
          let index =  this.indicators.indexOf(item);
          this.$refs.table.unselectRow(index)
        }
      },

			copy(){
				let copy = this.selected.map(i => ({text: i.indicador, value: i.value}));
				this.$emit("copy", copy)
				this.$bvModal.hide('CopyTreeToIndicator')
			}
		},

		mounted() {
				
		},
	}
</script>

<style scoped>

.table{
	height: 42vh;
}

.groupBtn{
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
}
.groupBtn img{
	display: flex;
	height: 35px;
	width: 35px;
}

.filter-box > input {
  border: 2px solid black;
  border-radius: 4px;
}

.space-select{
	min-height: 8vh;
}

.filter-box {
  margin-top: 5px;
}

.field-selected{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  max-height: 100px;
  overflow-y: auto;
}

.lines-selected{
  background-color: #00000013;
  padding: 0 4px;
  margin: 2px 5px;
  border-radius: 4px;
	box-shadow: 0 0 2px #0008;
}

.btn-clear{
  cursor: pointer;
}

</style>